import { Auth } from 'components/context/AuthContext';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  NotificationHeaderComponent,
  NotificationHeaderText,
  NotificationHeaderWrapper,
  NotificationUnread,
} from './NotificationHeader.styles';
import  { ReactHtmlParser } from 'helpers/utilities.js';
const NotificationHeader = ({ header, align }) => {
  const { notificationCount } = useContext(Auth);

  return (
    <NotificationHeaderComponent>
      <NotificationHeaderWrapper align={align}>
        <NotificationHeaderText align={align}>
          {ReactHtmlParser(header)}
          <NotificationUnread>{notificationCount} unread</NotificationUnread>
        </NotificationHeaderText>
      </NotificationHeaderWrapper>
    </NotificationHeaderComponent>
  );
};

NotificationHeader.propTypes = {
  header: PropTypes.string,
  align: PropTypes.string,
};
export default NotificationHeader;
